import QuickQuote from "./quickQuote"

export default QuickQuote
